(function ($, window, _, eventhub, cssCreator) {
	'use strict';
	/**
	 *
	 * @param name {string} - string which contains card type
	 * @returns {string} - card type
	 */
	var getCardType = function (name) {
		if (name && _.isString(name)) {
			return name.substring(0, name.indexOf('_my_methods'));
		}
		return '';
	};
	var pluginName = 'PMSelectV';
	var ghostClickElapsedTime = 20;
	var _lastEventTimestamp;
	var constants = {
		onlyOnePmClassName     : 'lonely',
		groupOpenClassName     : 'g_open',
		groupActiveClassName   : 'g_active',
		supportedImageMimeType : {
			"image/gif"     : 1,
			"image/jpeg"    : 1,
			"image/png"     : 1,
			"image/svg+xml" : 1
		},
		resourceTypeUrl        : 'url'
	};

	var defaults = {
		setMainElementHeight : false,
		gallerySizeCover     : false,
		enableGrouping       : false,
		allowActiveGroupClosing : true,
		isScrollEnabled      : true,
		iScroll: {
			scrollY               : true,
			tap                   : true,
			scrollbars            : true, // if '1' => use custom colors
			mouseWheel            : true,
			interactiveScrollbars : true,
			shrinkScrollbars      : 'scale',
			fadeScrollbars        : false,
			snap                  : false, //true
			scrollbarClass        : 'myScrollbar'
		},
		minVisiblePrimary  : 3,
		pm_order_prefix       : '', 		// when the plugin is used as a sub gallery
		showControls       : false,
		staticControls	   : false,
		animationSpeed	   : 250,
		asteriskTemplate   : "*",
		verticalAdjustment : 13,
		reduce_by_id       : "",
		wrapperHeightCorrection : 0,     // Fix Chrome table height bug
		itemContainerTagName : 'li',
		onClickSelector      : 'li',
		renderSeparately     : true,
		showUserPMs          : true,
		showMerchantPM       : true,
		reduceApplePayPriority : false, // preselection
		showApplePayInline   : false, // as regular PM
		activeElementClass   : 'selected',
		pms_label            : 'Payment Methods',
		pm_label           : 'Other Payment Methods',
		user_pm_label      : 'My Payment Methods',
		mainTemplate       : '<div class="pm-vertical-wrapper"></div>',
		ccCardTemplate	   : '<div class="cc-card-medium cc_card"><div class="x-middle visa cc-first"></div><div class="x-middle master_card"></div><div class="x-middle cc-third"></div><div class="x-middle cc-fourth"></div></div>',
		regExCardPattern   : /\((\d{4})\)|\d\*{4}(\d{4})|\d\*{3}\s+\*{4}\s+\*{4}\s+(\d{4})/,	// matches (1234) and 3****1234 and 1*** **** **** 3567
		customCssObjCreator : function(imgUrl, className){ return {background: "url('"+ imgUrl+ "') no-repeat center center;"}; },
		customCssRuleSelectorSufix: '', // '' | '::after' | '::before',
		appleNavTemplate  :
		'<div class="apple_pay_wrapp hidden">' +
			'<div class="apple">' +
				'<div class="btn_container">' +
					'<div class="pm-logo ">' +
						'<div class="pm-logo ppp_applepay"></div>' +
					'</div>' +
					'<div class="text"><%- t("ppp_ApplePay")%></div>' +
				'</div>' +
			'</div>' +
		'<p class="or_separator"><span><%- t("applepay_or_separator")%></span></p>' +
			'<div class="other">' +
				'<div class="btn_container">' +
					'<div class="pm-logo other_pms" ></div>' +
					'<div class="text"><%- t("other_pms")%></div>' +
				'</div>' +
			'</div>' +
		'</div>'
		,
		templates          : {
			wrapperPMTemplate: _.template('<div class="<%= data_type%> payment_header noselect"><span class="payment_header_label"><%= title%></span></div><div class="<%- data_type%> list-container"><div><ul class="<%- ulClass%>"></ul></div></div>'),
			itemPMTemplate   : _.template('<li data-value="<%-itemId %>" data-type="<%- type %>" data-pm-name="<%- pmName %>"><%=itemTemplate%></li>'),
			userPMTemplate   : _.template('<div class="<%-classPrefix%> pm_container"><div class="<%-classPrefix%> pm_side_status"></div><div class="<%-classPrefix%> pm_available " title="<%- ((details == \'&nbsp;\') ? \'\' : details) %>"><div class="upm-logo <%-showClass%>"></div><%if (details !== \'&nbsp;\'){ %><div class="<%-classPrefix%> pm-details"><%=details%></div><% } %></div></div>'),
			myPMTemplate     : _.template('<div class="<%=classPrefix%> pm_container"><div class="<%-classPrefix%> pm_side_status"></div><div class="<%=classPrefix%> pm_available" title="<%-label%>"><div class="pm-logo <%-showClass%>"><% if (hasNoClass) { %><%-label%><%}%></div></div></div>')
		}
	};
	var DATA_TYPE = {
		PMS : 'pms',
		UPM : 'user_pm',
		PM  : 'pm'
	};// options.renderSeparately

	var APPLE = {
		APPLE_PM_NAME         : "ppp_ApplePay",
		APPLE_PM_CLASS        : "ppp_applepay",
		HAS_APPLE_PM_CLASS    : "withApplePay",
		VISIBLE_GALLERY_CLASS : "show_gallery"
	};


	var handleClicks = function (mainElm, options, ctx) {
		var self 			 = ctx;
		var allowClickSamePM = options.allowClickSamePM;

		mainElm.on('click tap', options.onClickSelector, function (evt, data) {
			var dataToSend = null;
			var currentTime = (new Date()).getTime();
			// ghost click events
			if (currentTime - _lastEventTimestamp < ghostClickElapsedTime) {
				_lastEventTimestamp = currentTime;
				return true;
			}
			var liElm = $(evt.target).closest(options.itemContainerTagName);
			var uniqueId = liElm.data('value');
			var isAlreadySelected = liElm.hasClass(options.activeElementClass);
			if(self.Groups && self.Groups[uniqueId]){
				self.manageGroupedPMs(uniqueId, liElm);
				_lastEventTimestamp = currentTime;
				return;
			}
			if (!isAlreadySelected || allowClickSamePM) {
				if (isNaN(parseInt(uniqueId, 10))) {
					dataToSend = self.options.pm_data[uniqueId];
				} else {
					dataToSend = self.options.user_pm_data[_.findIndex(self.options.user_pm_data, {uniqueId : uniqueId})];
				}
				dataToSend.pmPosition = self.order[uniqueId];
				dataToSend._prevGroupId = self.selected && self.selected.groupId;
				self.selected = dataToSend;
				self.unselect();
				self.select(liElm);
				eventhub.publish('select-pm', [dataToSend, self, this, data]);
			} else {
				eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason:"already_selected"}, self, this]);
			}
			_lastEventTimestamp = currentTime;
			evt.preventDefault();
		});
	};

	/**
	 * Plugin constructor
	 * @param element
	 * @param options
	 * @constructor
	 */
	function Plugin(element, options) {
		options = options || {};
		if (!options.onClickSelector && options.itemContainerTagName) {
			options.onClickSelector = options.itemContainerTagName;
		}
		this.options = $.extend(true, {}, defaults, options);
		this.hasApplePay = false;
		this.count_upm = 0;
		this.count_pm = 0;
		this.$mainElement = $(element);

		this.$appleNav = $(this.options.showApplePayInline ? '<div class="apple_pay_wrapp hidden">' : _.template(this.options.appleNavTemplate)());
		this.$appleBtn = this.$appleNav.find('.apple');
		this.$mainElement.append(this.$appleNav);

		var wrapper_template = _.template(this.options.mainTemplate); // "pm-vertical-wrapper"
		this.wrapper = $(wrapper_template(this.options));
		this.$mainElement.append(this.wrapper);
		this.init();

	}

	Plugin.prototype.init = function () {
		cssCreator.setup(this.options.cssCreator);
		if (this.options.showMerchantPM) {
			eventhub.subscribe('pm-available', function (data) {
				this.updateData('pm', data);
			}, this);
		}
		if (this.options.showUserPMs) {
			eventhub.subscribe('user-pm-available', function (data) {
				this.updateData('user_pm', data);
			}, this);
		}
		eventhub.subscribe('dr-select-pm', function (data) {
			var uniqueId = (data.type && data.type === 'int') ? parseInt(data.uniqueId, 10) : data.uniqueId;
			this.handleDR(uniqueId, data.type, data.manual, data.allowApplePayAutoSelect);
		}, this);
		handleClicks(this.wrapper, this.options, this);
		$(window).resize(_.bind(this.recalculateSize, this));
		this.addAppleEvents();
	};

	Plugin.prototype.addAppleEvents = function () {
		var self = this;
		if(!self.options.showApplePayInline) {
			self.$appleNav.on('click tab', ".apple", function (e) {
				self.selectApplePay();
			});
			self.$appleNav.one('click tab', ".other", function (e) {
				_showOtherMethods(self);
			});
		} else if (self.$appleNav) {
			_showOtherMethods(self);
		}
	};

	function _showOtherMethods(self){
		if(self.hasApplePay && self.wrapper.hasClass('hidden')) {
			self.$appleNav.addClass('show_gallery');
			self.wrapper.removeClass('hidden');
			$(window).trigger('resize');
		}
	}

	Plugin.prototype.selectApplePay = function (manual) {
		var self = this;
		var $el = $(self.options.itemContainerTagName + '[data-value="ppp_ApplePay"]', self.wrapper);
		if ($el.length > 0) {
			var $targetElm = $(self.options.onClickSelector, $el);
			if ($targetElm.length === 0) {
				$targetElm = $el;
			}
			$targetElm.trigger('click', manual);
			if (self.hasApplePay && !self.options.showApplePayInline) {
				$(".apple", self.$appleNav).addClass(self.options.activeElementClass);
			} else {
				var scroll_type = (!self.options.renderSeparately) ? 'scroll_pms' : 'scroll_pm';
				(self[scroll_type]) ? self[scroll_type].scrollToElement($targetElm[0]) : '';
			}
			return true;
		}
	};

	Plugin.prototype.manageGroupedPMs = function (groupId, $liGroupElm) {
		var self = this;
		if(groupId && self.Groups[groupId] && self.Groups[groupId].pm_list.length ){
			var $liElms = $(self.options.itemContainerTagName + '[data-group="' + groupId + '"]');
			if($liGroupElm && $liGroupElm.hasClass(constants.groupOpenClassName)){
				if(self.options.allowActiveGroupClosing || self.selected && self.selected.groupId !== groupId){
					$liGroupElm.removeClass(constants.groupOpenClassName);
					$liElms.addClass('hidden');
				}
			} else {
				$liGroupElm.addClass(constants.groupOpenClassName);
				$liElms.removeClass('hidden');
			}
			self.recalculateSize();
		}
	};

	Plugin.prototype.select = function ($liElm) {
		var self = this;
		$liElm.addClass(self.options.activeElementClass);
		$liElm.find('.pm_side_status').addClass('arrow-div');
		if (self.options.enableGrouping) {
			var groupId = (self.selected && self.selected.groupId);
			if (groupId) {
				var $liGroupElm = $(self.options.itemContainerTagName + '[data-value="' + groupId + '"]', self.wrapper);
				$liGroupElm.addClass(constants.groupActiveClassName);
				if (groupId !== self.selected._prevGroupId && !$liGroupElm.hasClass(constants.groupOpenClassName)) {
					self.recalculateSize();
					// $liGroupElm.addClass(constants.groupOpenClassName); // OR expand the group ?
				}
			}
			else if (self.selected._prevGroupId) {
				var $prevLiGroupElm = $(self.options.itemContainerTagName + '[data-value="' + self.selected._prevGroupId + '"]', self.wrapper);
				if (!$prevLiGroupElm.hasClass(constants.groupOpenClassName)) {
					self.recalculateSize();
				}
			}
		}
	};

	Plugin.prototype.unselect = function () {
		var activeElementClass = this.options.activeElementClass;
		this.$appleBtn.removeClass(activeElementClass);
		this.wrapper.find('.' + activeElementClass + ' .pm_side_status').removeClass('arrow-div');
		this.wrapper.find('.' + activeElementClass).removeClass(activeElementClass);
		this.wrapper.find('.' + constants.groupActiveClassName).removeClass(constants.groupActiveClassName);
	};

	Plugin.prototype.handleDR = function (uniqueId, idType, manual, allowApplePayAutoSelect) {
		var self = this;
		var $el, scroll_type;
		if (self.hasApplePay && allowApplePayAutoSelect && (!(self.options.user_pm_data && self.options.user_pm_data.length) || !self.options.reduceApplePayPriority)) {
			self.selectApplePay(manual);
			return;
		}
		if (uniqueId === "auto_select" && idType === "auto_select") {
			$el = $(this.options.itemContainerTagName + '[data-value]', self.wrapper).first();
			scroll_type = isNaN(parseInt($el.data('value'), 10)) ? 'scroll_user_pm' : 'scroll_pm';
		} else if (uniqueId === "auto_select" && idType === "pm") {
			$el = $(this.options.itemContainerTagName + '[data-value][data-type="pm"]', self.wrapper).first();
			scroll_type = isNaN(parseInt($el.data('value'), 10)) ? 'scroll_user_pm' : 'scroll_pm';
		} else {
			$el = $(this.options.itemContainerTagName + '[data-value="' + uniqueId + '"]', self.wrapper);
			scroll_type = (idType === 'int') ? 'scroll_user_pm' : 'scroll_pm';
		}
		scroll_type = (!this.options.renderSeparately) ? 'scroll_pms' : scroll_type;
		if ($el.length > 0) {
			var $targetElm = $(this.options.onClickSelector, $el);
			if ($targetElm.length === 0) {
				$targetElm = $el;
			}
			$targetElm.first().trigger('click', manual);
			(this[scroll_type]) ? this[scroll_type].scrollToElement($el[0]) : '';
			if (self.hasApplePay && self.$appleNav && (uniqueId != 'ppp_ApplePay' || self.options.showApplePayInline)) {
				_showOtherMethods(self);
			}
		} else {
			eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason : "incorrect_id"}, self, this]);
		}
	};

	Plugin.prototype.handleScrollbarVisibility = function () {
		var self = this;
		_.each(['user_pm', 'pm', 'pms'], function (data_type) {
			var current = self['$' + data_type];
			if (current) {
				var parent = current.parent();
				if (current.height() - parent.height() <= 0) {
					$('.iScrollLoneScrollbar', parent).hide();
				}
				else {
					$('.iScrollLoneScrollbar', parent).show();
				}
				self['scroll_' + data_type].refresh();
			}
		})
	};

	/**
	 *
	 * @param data_type ( pm | user_pm | pms)
	 */
	Plugin.prototype.setupControls = function (data_type) {
		var self = this;
		var dtScroll = this['scroll_' + data_type];
		var parent = this['$' + data_type].parent().get(0);
		var wrapper = $(dtScroll.wrapper).parent();
		var controls = "<div class='iscroll-controls-vertical'><button type='button' class='up'>Up</button><button type='button' class='down'>Down</button></div>";

		wrapper.append(controls);

		$('.down', wrapper).attr("disabled", !(dtScroll.y > dtScroll.maxScrollY && dtScroll.scrollerHeight > dtScroll.wrapperHeight));
		$('.up', wrapper).attr("disabled", dtScroll.y == 0); //true

		if (this.options.staticControls) {
			wrapper.addClass('iscroll-controls-static')
		}

		dtScroll.on('scrollEnd', function () {
			if (this.y == 0) {
				$('.up', wrapper).attr('disabled', true);
			}
			if (this.y < 0) {
				$('.up', wrapper).attr('disabled', false);
			}
			if (this.y == this.maxScrollY) {
				$('.down', wrapper).attr('disabled', true);
			}
			if (this.y > this.maxScrollY) {
				$('.down', wrapper).attr('disabled', false);
			}
		});

		$('.down', wrapper).on('click', function () {
			if ((dtScroll.y - $(parent).height()) <= dtScroll.maxScrollY) {
				dtScroll.scrollTo(0, dtScroll.maxScrollY, self.options.animationSpeed);
				$('.down', wrapper).attr('disabled', true);
			}
			else {
				dtScroll.scrollBy(0, -$(parent).height(), self.options.animationSpeed);
			}
			$('.up', wrapper).attr('disabled', false);
		});

		$('.up', wrapper).click(function () {
			if ((dtScroll.y + $(parent).height()) >= 0) {
				dtScroll.scrollTo(0, 0, self.options.animationSpeed);
				$('.up', wrapper).attr('disabled', true);
				$('.down', wrapper).attr('disabled', false);
			}
			else {
				dtScroll.scrollBy(0, $(parent).height(), self.options.animationSpeed);
				$('.down', wrapper).attr('disabled', false);
			}
		});
		this.recalculateSize();
	};

	Plugin.prototype.updatePmPosition = function () {
		var self = this;
		var order = {};
		var items = self.wrapper.find(self.options.itemContainerTagName + '[data-value]');

		_findOrder(items, self.options.pm_order_prefix);
		self.order = order;

		function _findOrder(items, prefix) {
			prefix == prefix || '';
			var count = 0;
			var giCount = 0;
			var upoCount = 0;
			var arr = items.toArray();
			_.each(arr, function (item, idx) {
				var $i = $(item);
				var id = $i.attr("data-value");
				var isUpo = $i.attr("data-type") === "user_pm";
				var groupItem = $i.attr("data-group");
				var pos, subPos;
				if (isUpo) {
					pos = prefix + (++count);
					subPos = '' + (++upoCount);
				} else if (groupItem) {
					pos = prefix + order[groupItem].absolute + "." + (++giCount);
					subPos = order[groupItem].relative + "." + giCount;
				} else {
					pos = prefix + (id === 'ppp_ApplePay' && !self.options.showApplePayInline ? '0' : ++count);
					subPos = '' + (id === 'ppp_ApplePay' && !self.options.showApplePayInline ? '0' : count - upoCount);
					giCount = 0;
				}
				order[id] = {absolute: pos, relative: subPos}; // relative to PM gallery type
			});
		}
	};

	Plugin.prototype.render = function (currentListElm, data_type) {
		function renderItem(item, data_type, tpl) {
			var $elm = $(self.options.templates.itemPMTemplate({
				itemId       : item.uniqueId,
				pmName       : item.pmName,
				itemTemplate : tpl(item),
				type         : data_type
			}));
			if (item.groupId) {
				$elm.attr('data-group', item.groupId).addClass('hidden');
			}
			if (item.isPmGroup) {
				$elm.addClass('pm_group');
			}
			if (item.promotedPM) {
				$elm.addClass("promotedPM");
			}
			if (item.additionalClass) {
				$elm.addClass(item.additionalClass);
			}
			return $elm;
		}

		function listItems(parentElm, data, data_type, isGroupMember) {
			var itemContentTemplate = {
				user_pm : (_.isString(self.options.templates.userPMTemplate) ? _.template(self.options.templates.userPMTemplate) : self.options.templates.userPMTemplate),
				pm      : (_.isString(self.options.templates.myPMTemplate) ? _.template(self.options.templates.myPMTemplate) : self.options.templates.myPMTemplate)
			};
			_.each(data, function (item, idx) {
				switch (data_type) {
					case 'user_pm':
						if (item.imgUrl) {
							var cssObj = self.options.customCssObjCreator(item.imgUrl, item.showClass);
							cssCreator.addCustomRule(item.showClass + self.options.customCssRuleSelectorSufix, cssObj);
						} else {
							cssCreator.makeRule(item.showClass);
						}
						break;
					case 'pm':
						item.hasNoClass = (item.showClass === 'cc_card' || item.showClass === 'dc_card') ? false : !cssCreator.makeRule(item.showClass);
						break;
				}
				if (isGroupMember || !item.groupId) {
					parentElm.append(renderItem(item, data_type, itemContentTemplate[data_type]));
				}
				if (item.isPmGroup && item.pm_list) {
					listItems(parentElm, item.pm_list, data_type, true);
				}
			});
		}

		var self = this;
		var currentData = this.options[data_type + '_data'] || [];
		if (currentListElm) {
			currentListElm.find(self.options.itemContainerTagName + '[data-type="' + data_type + '"]').remove();
			var docFragment = $(document.createDocumentFragment());
			listItems(docFragment, currentData, data_type);
			if (data_type === 'user_pm' && !self.options.renderSeparately) {
				currentListElm.prepend(docFragment);
			} else {
				currentListElm.append(docFragment);
			}
		}
		if ((self.count_upm + self.count_pm) === 1) {
			self.$appleNav.addClass(constants.onlyOnePmClassName);
		} else {
			self.$appleNav.removeClass(constants.onlyOnePmClassName);
		}
	};

	Plugin.prototype.updateData = function (data_type, data) {
		data || (data = []);
		var self = this;
		var currentData = null;
		if (data_type === "pm") {
			currentData = this.pm(data);
		}
		if (data_type === "user_pm") {
			currentData = this.userPM(data);
		}
		this.options[data_type + '_data'] = currentData;

		var currentDataSize = _.size(currentData);
		var type = ( !this.options.renderSeparately ) ? 'pms' : data_type ;
		var ulSelector = '.' + type + '.pm-list';

		if (currentDataSize && !this.wrapper.find(ulSelector).length) {
			var $pmWrapperFirstElm = this.wrapper.find('[data-wrapper_type_start="pm"]');
			var $dataTypeWrapperHtml = $(this.options.templates.wrapperPMTemplate({
				title     : this.options[ type + '_label'],
				ulClass   : type + ' pm-list',
				data_type : type
			}));
			$dataTypeWrapperHtml.first().attr("data-wrapper_type_start", type);
			if (this.options.renderSeparately && data_type === 'user_pm' && $pmWrapperFirstElm.length) {
				$pmWrapperFirstElm.before($dataTypeWrapperHtml);
			} else {
				this.wrapper.append($dataTypeWrapperHtml);
			}
			this['$' + type] = this.wrapper.find(ulSelector);
		}

		var currentListElm = this['$' + type];

		if (currentListElm) {
			this.render(currentListElm, data_type);
			this.updatePmPosition();

			var listWrapper = currentListElm.parent();
			listWrapper.height('300px');
			listWrapper.css('overflow', 'hidden');
			listWrapper.css('position', 'relative');
			_handlePaymentHeader(self, data_type, currentDataSize);
			if(data_type === "pm") {
				_handleApplePayClasses(self);
			}
		}
		if (this.options.ccCardTemplate) {
			$('.pm-logo.cc_card, .pm-logo.dc_card').html(this.options.ccCardTemplate);
		}

		this.updateScroll();
		this.recalculateSize();
		eventhub.publish('app.event.pmselectv.postRender', [{data_type: data_type}]);
		eventhub.publish('app.event.gallery.postRender', [{data_type: data_type, plugin: 'pmselectv'}]);
	};

	Plugin.prototype.updateScroll = function () {
		var self = this;
		var dataTypeArray = ( !this.options.renderSeparately ) ? ['pms'] : ['pm', 'user_pm'];
		_.each(dataTypeArray, function(data_type){
			if (!self['scroll_' + data_type] && self['$' + data_type]) {
				var newScrollObj = function () {
					this.isFake          = true;
					this.refresh         = _.identity;
					this.scrollToElement = _.identity;
					this.scrollTo        = _.identity;
					this.scrollBy        = _.identity;
					this.on              = _.identity;
				};

				if (self.options.isScrollEnabled ) {
					newScrollObj = IScroll;
				}
				self['scroll_' + data_type] = new newScrollObj(self['$' + data_type].parent()[0], self.options.iScroll);
				self['scroll_' + data_type].refresh();
				setTimeout(function () {
					if (self['scroll_' + data_type]) {
						self['scroll_' + data_type].refresh();
						var $wrapper = $(self['scroll_' + data_type].wrapper).parent();
						if (self.options.showControls && $('.iscroll-controls-vertical', $wrapper).length == 0) {
							self.setupControls(data_type);
							self.handleScrollbarVisibility();
						}
					}
				}, 100);
			}
		});
	};

	/**
	 * recalculate size of container relative to viewport height
	 */
	Plugin.prototype.recalculateSize = function () {
		var itemHeight        = 0;
		var items1            = 0;
		var items2            = 0;
		var headersHeight     = 0;
		var minVisiblePrimary = this.options.minVisiblePrimary;

		if (this.$user_pm && this.$user_pm.children().length) {
			var $upm_items = $(this.options.itemContainerTagName, this.$user_pm);
			itemHeight     = $upm_items.first().outerHeight(true);
			items1         = $upm_items.length;
			headersHeight += this.$user_pm.closest('.list-container').prev().outerHeight(true);
		}
		if (this.$pm && this.$pm.children().length) {
			var $pm_items  = $(this.options.itemContainerTagName, this.$pm);
			itemHeight     = $pm_items.first().outerHeight(true);
			items2         = $pm_items.length;
			headersHeight += this.$pm.closest('.list-container').prev().outerHeight(true);
		}
		if (this.$pms && this.$pms.children().length) {
			var $pms_items = $(this.options.itemContainerTagName, this.$pms);
			itemHeight     = $pms_items.first().outerHeight(true);
			items1         = $pms_items.length;
			headersHeight += this.$pms.closest('.list-container').prev().outerHeight(true);
		}
		var allItems = items1 + items2;
		var allItemsHeight = (allItems * itemHeight);

		allItemsHeight += headersHeight;
		var getHeightOfReduceElms = function(ids){
			var totalHeight = 0;
			if (ids === ''){
				return totalHeight;
			}
			var reduceIds = ids.split(' ');
			_.each( reduceIds, function (elmId) {
				var elm = $('#' + elmId);
				if (elm.length === 1){
					var opt = ( elm.css('display') !== "table-row" ); /* Fix Firefox behaviour */
					totalHeight += parseInt(elm.outerHeight(opt) || 0);
				}
			});
			return totalHeight;
		};
		var maxHeight = viewportSize.getHeight() - this.options.verticalAdjustment - getHeightOfReduceElms(this.options.reduce_by_id);
		var maxMainElementHeight = maxHeight;
		if(this.hasApplePay){
			maxHeight -=  parseInt($( '.apple_pay_wrapp', this.$mainElement).outerHeight(true)) || 0;
		}
		if (this.options.showControls && this.options.staticControls) {
			var $controlsStatic = $(".iscroll-controls-static");
			var pTop = $controlsStatic.css('padding-top');
				pTop = parseInt(pTop) || 0;
			var pBottom = $controlsStatic.css('padding-bottom');
				pBottom = parseInt(pBottom) || 0;
			var count = $controlsStatic.length;
			maxHeight -= (pTop + pBottom) * count;
		}
		var maxPossibleItems = Math.floor(( maxHeight - headersHeight) / itemHeight);

		if (allItemsHeight <= maxHeight) {
			if (this.$pms) {
				this.$pms.parent().height(allItems * itemHeight + this.options.wrapperHeightCorrection);
			} else {
				if (this.$user_pm) {
					this.$user_pm.parent().height(items1 * itemHeight + this.options.wrapperHeightCorrection);
				}
				if (this.$pm) {
					this.$pm.parent().height(items2 * itemHeight + this.options.wrapperHeightCorrection);
				}
			}
		} else if (!this.options.renderSeparately && this.$pms) {
			this.$pms.parent().height(this.options.gallerySizeCover ? Math.floor(maxHeight - headersHeight) : maxPossibleItems * itemHeight);
		} else {
			var item1v = Math.min(items1, Math.max(maxPossibleItems - items2, minVisiblePrimary));
			var item2v = Math.min(items2, Math.max(maxPossibleItems - item1v));
			if (this.$user_pm && this.$pm) {
				if (item1v <= minVisiblePrimary) {
					var primaryHeight = item1v * itemHeight;
					this.$user_pm.parent().height(primaryHeight);
					this.$pm.parent().height(maxHeight - primaryHeight - headersHeight);
				} else {
					var secondaryHeight = item2v * itemHeight;
					this.$user_pm.parent().height(maxHeight - secondaryHeight - (headersHeight ));
					this.$pm.parent().height(secondaryHeight);
				}
			} else if (this.$user_pm) {
				this.$user_pm.parent().height(this.options.gallerySizeCover ? Math.floor(maxHeight - headersHeight) : item1v * itemHeight);
			} else if (this.$pm) {
				this.$pm.parent().height(this.options.gallerySizeCover ? Math.floor(maxHeight - headersHeight) : item2v * itemHeight);
			}
		}
		if(this.options.setMainElementHeight){
			this.$mainElement.height(maxMainElementHeight);
		}
		this.updateControls();
		this.handleScrollbarVisibility();
	};

	Plugin.prototype.updateControls = function () {
		var self = this;
		if(self.options.showControls ) {
			var dataTypeArray = ( !self.options.renderSeparately ) ? ['pms'] : ['pm', 'user_pm'];
			_.each(dataTypeArray, function (data_type) {
				var dtScroll = self['scroll_' + data_type];
				if (dtScroll) {
					var $wrapper = $(dtScroll.wrapper).parent();
					$('.down', $wrapper).attr("disabled", !(dtScroll.y > dtScroll.maxScrollY && dtScroll.scrollerHeight > dtScroll.wrapperHeight));
					$('.up', $wrapper).attr("disabled", dtScroll.y == 0);
				}
			});
		}
	};

	function _createGroup(item) {
		return {
			uniqueId    : item.groupId,
			label       : item.groupLabel,
			name        : item.groupLabel,
			showClass   : (item.groupShowClass || item.groupLabel).toLowerCase(),
			isPmGroup   : true,
			isIframe    : false,
			details     : '',
			classPrefix : 'pm',
			pm_list     : [],
			rawData     : {}
		}
	}

	Plugin.prototype.pm = function (merchantPMArray) {
		var self = this;
		var retObj = {};
		self.hasApplePay = false;
		self.Groups = {};
		self.count_pm = 0;
		_.each(_.map(merchantPMArray, function (item, idx, arr) {
			var details     = "";
			var showClass   = (item.value || '').toLowerCase();
			var fee         = (item.attributes && item.attributes.customFees || {});
			var iframe      = null;
			if (item.attributes && _.has(item.attributes, 'isIframe')) {
				iframe = item.attributes.isIframe;
			}
			if (showClass === 'ppp_applepay') {
				self.hasApplePay = true;
			}
			if (item.groupId && !self.Groups[item.groupId]) {
				self.Groups[item.groupId] = _createGroup(item);
			}
			self.count_pm++;
			return {
				uniqueId     : item.value,
				label        : item.label,
				name         : showClass,
				pmName       : item.value,
				isIframe     : iframe,
				showClass    : showClass,
				details      : details || '',
				feeValue     : fee.feeValue ,
				feeValueType : fee.feeValueType ,
				feeType      : fee.feeType ,
				promotedPM	     : item.attributes.promotedPM,
				additionalClass  : item.attributes && item.attributes.additionalClass || '',
				rawData          : item  || {},
				classPrefix      : 'pm',
				groupId          : self.options.enableGrouping && item.groupId
			};
		}), function (elm) {
			if (self.options.enableGrouping && elm.groupId && self.Groups[elm.groupId]) {
				if (!retObj[elm.groupId]) {
					retObj[elm.groupId] = self.Groups[elm.groupId];
				}
				retObj[elm.groupId].pm_list.push(elm);
			}
			retObj[elm.uniqueId] = elm;
		});
		return retObj;
	};

	function _getUrl(metadata) {
		var url;
		if (metadata && metadata.imgContent && metadata.imgMimeType) {
			if (constants.supportedImageMimeType[metadata.imgMimeType]) {
				var normalizedString = (metadata.imgContent).replace(/(\r\n|\n|\r)/gm, "");
				url = ["data:", metadata.imgMimeType, ";base64,", normalizedString].join('');
			} else if (metadata.imgMimeType === constants.resourceTypeUrl) {
				url = metadata.imgContent.trim();
			}
		}
		return url;
	}

	Plugin.prototype.userPM = function (userPMArray) {
		var self = this;
		var ccCardDetails = this.options.regExCardPattern;
		self.count_upm = 0;
		return _.map(userPMArray, function (item) {
			var iframe    = null;
			var showClass = null;
			var details   = "";
			var fee       = item.customFees || {};
			var issuer    = item.cardIssuer;
			var uniqueId  = parseInt(item.userPaymentOptionId, 10) || -1;
			var url       = _getUrl(item.metadata);

			if (item.attributes && _.has(item.attributes, 'isIframe')) {
				iframe = item.attributes.isIframe;
			}

			if (ccCardDetails.test(item.name)) {
				details = this.options.asteriskTemplate + (item.name.match(ccCardDetails)[1] || item.name.match(ccCardDetails)[2] || item.name.match(ccCardDetails)[3]);
				showClass = item.type || item.card_type || getCardType(item.className) || item.paymentOptionName;
				issuer = issuer || showClass;
				// Hack for WD
				if (item.paymentOptionName === "visa_checkout") {
					showClass = item.paymentOptionName;
				}
			} else {
				showClass = item.paymentOptionName || item.type || item.card_type || getCardType(item.className);
				details = item.name;
				issuer = issuer || item.displayPaymentOptionName;
			}

			showClass = showClass.toLowerCase() + (url ? '_' + uniqueId + '_modified' : '');
			self.count_upm++;
			if(item.paymentOptionName === 'apmgw_MuchBetter'){
				details = details.replace('-','');
			}
			return {
				uniqueId     : uniqueId,
				label        : item.displayPaymentOptionName || '',
				name         : item.paymentOptionName || '',
				pmName       : item.paymentOptionName || '',
				isIframe     : iframe,
				showClass    : showClass,
				details      : details || '&nbsp;',
				feeValue     : fee.feeValue ,
				feeValueType : fee.feeValueType ,
				feeType      : fee.feeType ,
				rawData      : item || {},
				issuer       : issuer,
				imgUrl       : url || '',
				classPrefix  : 'upm',
				netDeposit   : item.netDepositValue || '',
				verificationStatus			 : item.verificationStatus || '',
				isLastUsedAccount : item.isLastUsedAccount || '',
				cardExpiryDate  : item.cardExpiryDate || '',
				additionalClass : item.additionalClass || ''
			};
		}, this);
	};

	function _handleApplePayClasses(self) {
		if (self.hasApplePay && !self.options.showApplePayInline) {
			self.$mainElement.addClass('withApplePay');
			self.$appleNav.removeClass('hidden');
			if(!self.$appleNav.hasClass('show_gallery')){
				self.wrapper.addClass('hidden');
			}
		} else {
			self.$mainElement.removeClass('withApplePay');
			self.wrapper.removeClass('hidden');
			self.$appleNav.addClass('hidden');
		}
		if (!self.options.showApplePayInline) {
			var $el = $(self.options.itemContainerTagName + '[data-value="ppp_ApplePay"]', self.wrapper);
			if ($el.length > 0) {
				$el.css('display', 'none');
			}
		}
	}

	function _handlePaymentHeader(self, data_type, hasData) {
		if (self.options.renderSeparately) {
			var header = self.wrapper.find('.' + data_type + '.payment_header');
			if (hasData) {
				header.removeClass('hidden');
			} else {
				header.addClass('hidden');
			}
		}
	}

	/**
	 * Plugin initialization
	 * @param options
	 * @returns {*}
	 */
	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			}
		});
	};
})(jQuery, window, _, pubsub, cssCreator);